import { useApiClient } from '../composables/useApiClient.ts';

export default {
    getDictionary() {
        return useApiClient().get('/bookkeepings/invoices/dictionary');
    },
    getBalanceTypeDictionary() {
        return useApiClient().get('/crms/balance-type/dictionary');
    },
};
